export const gameRoles: IGameRole[] = [
  {
    id: "none",
    title: "No Role",
    subTitle: "Standard Play",
    description: "Play the game with standard rules and no special abilities.",
    effect: "No special effects",
    playstyle: "Balanced",
    balanceNote: "Standard gameplay",
    color: "#6B7280",
  },
  {
    id: "rent-lord",
    title: "Rent Lord",
    subTitle: "Property Income Specialist",
    description: "Master of property income with enhanced rent collection abilities.",
    effect: "Get 50% more rent on all properties",
    playstyle: "Aggressive map control",
    balanceNote: 'Cannot charge bonus on mortgaged properties or when using "trap" rent cards',
    color: "#F59E0B",
  },
  {
    id: "auction-strategist",
    title: "Auction Strategist",
    subTitle: "Bidding Expert",
    description: "Master of auctions with strategic bidding advantages.",
    effect: "When he wins an auction he has to pay 100 less",
    playstyle: "Smart investor, economic edge",
    balanceNote: "Cannot use both powers in the same auction",
    color: "#8B5CF6",
  },
  {
    id: "card-stealer",
    title: "Trickster",
    subTitle: "Card Collection Expert",
    description: "Specializes in collecting and utilizing action/event cards.",
    effect: "Get two cards on action tile instead of one",
    playstyle: "Disruptive chaos engine",
    balanceNote: "Maximum of 6 cards in hand at any time",
    color: "#EC4899",
  },
  {
    id: "wall-street-wolf",
    title: "Wall Street Wolf",
    subTitle: "Investment Expert",
    description: "Specializes in capital investments and stock market gains.",
    effect: "Get double returns on stock as compared to others",
    playstyle: "Focuses on capital investments and circuiting the board",
    balanceNote: "Cannot combine with interest-based event cards",
    color: "#10B981",
  },
  {
    id: "private-buyer",
    title: "Private Buyer",
    subTitle: "Direct Purchase Specialist",
    description: "Has exclusive rights to purchase properties without auctions.",
    effect: "Can buy 4 properties on landing without auction",
    playstyle: "Early expansion",
    balanceNote: "After 4 purchases, must join auctions like others",
    color: "#3B82F6",
  },

  {
    id: "financer",
    title: "The Financier",
    subTitle: "Financial Specialist",
    description: "Starts with more capital but has restrictions on bonus income.",
    effect: "Get +500 in start and +100(total 300) on round completion",
    playstyle: "Fast-paced investor",
    balanceNote: "Good early game, reduced bonus in late game",
    color: "#6366F1",
  },
]
